import { render, staticRenderFns } from "./RsaOspiteAnagraficaComponent.vue?vue&type=template&id=720e37c6"
import script from "./RsaOspiteAnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./RsaOspiteAnagraficaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports